import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ConfirmationDialogData {
  title: string;
  message: string;
  highlightText?: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'warning' | 'danger' | 'info';
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {
  constructor(private dialog: MatDialog) {}

  confirm(data: ConfirmationDialogData): Observable<boolean> {
    const dialogRef: MatDialogRef<ConfirmationDialogComponent, boolean> = this.dialog.open(
      ConfirmationDialogComponent,
      {
        width: '450px',
        data: {
          title: data.title,
          message: data.message,
          highlightText: data.highlightText,
          confirmText: data.confirmText || 'Confirm',
          cancelText: data.cancelText || 'Cancel',
          type: data.type || 'warning'
        },
        disableClose: false,
        autoFocus: false
      }
    );

    return dialogRef.afterClosed().pipe(
      map(result => result === true)
    );
  }

  confirmDelete(itemName: string): Observable<boolean> {
    return this.confirm({
      title: 'Confirm Delete',
      message: 'Are you sure you want to delete truck',
      highlightText: itemName,
      confirmText: 'Delete',
      cancelText: 'Cancel',
      type: 'danger'
    });
  }
}
